module.exports = __webpack_public_path__ + "img/郭永林.b9acb406.jpg";